import type { Reducer } from 'redux';

import type { PushSubscriptionServerKeyLoadAction } from '../../domains/pushSubscriptionServerKey/actions.types';
import { setFulfilled, setPending, setRejected } from '../types';

import type { PushSubscriptionServerKey } from './types';

const initialState: PushSubscriptionServerKey = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<PushSubscriptionServerKey, PushSubscriptionServerKeyLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'PUSH_SUBSCRIPTION_SERVER_KEY.LOAD_PENDING':
      return setPending();
    case 'PUSH_SUBSCRIPTION_SERVER_KEY.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'PUSH_SUBSCRIPTION_SERVER_KEY.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    default:
      return state;
  }
};

export default reducer;
